var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c('span',{staticClass:"ag-block__featured-image"},[_c('img',{attrs:{"src":_vm.image.full_url,"alt":_vm.title,"width":"100"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }